export default __webpack_public_path__ + "static/media/Elixir of Mystical Excellence.3dad3808.jpg";